<div id="manageEvent" style="margin-top: 4rem;" #events>
    <router-outlet></router-outlet>
</div>
